module.exports = __webpack_public_path__ + "static/media/ETS_Video1130x810.18dfc378.mp4";